export function upsertRouteTab(existing, current, maxCloseable = 8) {
  if (existing.some((tab) => tab.id === current.id)) return existing;
  const nextTab = { ...current, kind: "route", pinned: current.canonical === "/panel", closeable: current.canonical !== "/panel", dirty: false };
  if (existing.filter((tab) => tab.closeable).length < maxCloseable) return [...existing, nextTab];
  const evict = existing.findIndex((tab) => tab.closeable && tab.id !== current.id);
  if (evict < 0) return existing;
  return [...existing.slice(0, evict), ...existing.slice(evict + 1), nextTab];
}
